import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Drawer,
  Box,
  Badge,
  IconButton,
  Tooltip,
  Popover,
  Tab,
  List,
  ListItemText,
  Button,
  Typography,
  Collapse,
  TextField,
  Divider,
  ListItemButton,
  ListItemIcon,
  Radio,
  ListItem,
  MenuItem,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  styled,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getExpert,
  setUpdateExpertsStatus,
  updateExpert,
} from "../../../redux/slices/expertSlice/addExpertSlice";
import { useNavigate, useParams } from "react-router-dom";
import PaginationEntries from "../../pagination/paginationEntries";
import Pagination from "./testAttemptsPagination";
import { SearchBar } from "../../inputField/textfield";
import { useStyles } from "../../../assets/styles/listTableStyle";
import TableRowItem from "./testAttemptsTableRow";
import Error from "../../error/error";
import debounce from "lodash.debounce";
import { AppDispatch, RootState } from "../../../redux/store/appStore";
import { STATUS } from "../../../utils/status";
import { TableCellHead } from "../../table/tableCell";
import DeleteModal from "../../modal/deleteModal";
import SnackbarNotification from "../../snackbar/snackbarNotification";
import {
  getExpertTestAttempts,
  getExpertTestAttemptsDownload,
  getTestAttempts,
  getTestAttemptsDownload,
  setDownloadAttemptStatus,
  setDownloadRawAttemptStatus,
} from "../../../redux/slices/testAttempts";
import AttemptHistory from "./attemptHistory";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import CancelIcon from "@mui/icons-material/Cancel";
import BlockIcon from "@mui/icons-material/Block";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import RestoreIcon from "@mui/icons-material/Restore";
import DatePicker from "react-datepicker";
import EastIcon from "@mui/icons-material/East";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format } from "date-fns";
import dayjs, { Dayjs } from 'dayjs';
import DownloadIcon from '@mui/icons-material/Download';
import { updateProjectExpert } from '../../../redux/slices/projectSlice/addProjectSlice';
import { usePollingTaskStatus } from '../../outputJson/usePollingStatus';
import { getOutputJsonTaskStatus, setTaskStatus } from '../../../redux/slices/outputJson';


import DrawerFilters from '../../Filters In Drawer/DrawerFilters';

const TestAttemptsListTable = () => {
    const classes = useStyles();
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    // new 
    const { getTaskStatusOutputJson, getTaskStatusOutputJsonMessage, taskStatusOutputJsonResponse } = useSelector((state: RootState) => state.outputJson);
    const [openTaskStatusModal, setOpenTaskStatusModal] = useState(false);
    //
    const [taskStatusModalOpen, setTaskStatusModalOpen] = useState(false);
    const [taskStatusData, setTaskStatusData] = useState<any>(null);
    const [celeryTaskId, setCeleryTaskId] = useState<string | undefined>(undefined);
    const outputJsonStatus = useSelector((state: RootState) => state.outputJson.taskStatusOutputJsonResponse);

    const [currentPage, setCurrentPage] = useState(1);
    const [selectedValue] = useState('');
    const [itemsPerPage, setItemsPerPage] = useState<number>(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [userIdToDelete, setUserIdToDelete] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error" | "info" | "warning">("success");
    const attempts = useSelector((state: RootState) => state.testAttempts.testAttempts);
    const { id } = useParams();
    const [drawer, setDrawer] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [attemptId, setAttemptId] = useState<string>();
    const [filterCountApplied, setFilterCountApplied]: any = useState(0)
    const [anchorE3, setAnchorE3] = useState(false);
    const [value, setValue] = useState('1')
    const [searchType, setSearchType] = useState("")
    const [attemptListOpen, setAttemptListOpen] = useState(false)
    const [filterInFocus, setfilterInFocus] = useState('')
    const [openList, setOpenList] = useState<string | null>(null);
    const [attemptValue, setAttemptValue] = useState(null)
    const [statusOpen, setStatusOpen] = useState(false)
    const [selectedSatatus, setSelectedStatus] = useState(null)
    const [dateOpen, setdateOpen] = useState(false)
    const [isEndDateOpen, setIsEndDateOpen] = useState(false);
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const [minScore, setMinScore] = useState("")
    const [maxScore, setMaxScore] = useState("")
    const [attemptStatus, setAttemptStatus] = useState([])
    const [passingPercentOpen, setPassingPercentOpen] = useState(false)
    const [minPercent, setMinPercent] = useState("")
    const [maxPercent, setMaxPercent] = useState("")
    const [isAttemptEmailSearch, setIsAttemptEmailSearch] = useState(false)

  const minScoreRef = useRef<HTMLInputElement | null>(null);

  const getStatus = useSelector(
    (state: RootState) => state.testAttempts.getTestAttemptsStatus
  );
  const getDownloadStatus = useSelector(
    (state: RootState) => state.testAttempts.getTestAttemptsDownloadStatus
  );
  const getDownloadRawDataStatus = useSelector(
    (state: RootState) => state.testAttempts.getExpertTestAttemptsDownloadStatus
  );
  const getDownloadGroupedDataMessage = useSelector(
    (state: RootState) => state.testAttempts.getTestAttemptsDownloadMessage
  );
  const getDownloadRawDataMessage = useSelector(
    (state: RootState) => state.testAttempts.getExpertTestAttemptsDownloadMessage
  );
  const updateStatus = useSelector(
    (state: RootState) => state.experts.updateStatus
  );
  const attemptsExpertDownload = useSelector(
    (state: RootState) => state.testAttempts.attemptsExpertDownload
  );
  const expertAttemptsExpertDownload = useSelector(
    (state: RootState) => state.testAttempts.expertTestAttemptsDownload
  );
  const association_type = useSelector(
    (state: RootState) => state.projects.association_type
  );
  const association_type_vendor =
    association_type && association_type === "VENDOR";

  const hasFilters =
    !!attemptValue ||
    !!attemptStatus ||
    !!startDate ||
    !!endDate ||
    !!searchType ||
    !!minScore ||
    !!maxScore ||
    !!minPercent ||
    !!maxPercent;

  useEffect(() => {
    if (!hasFilters) return;

    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = ""; // required for Chrome/Edge
    };

    window.addEventListener("beforeunload", handler);

    return () => {
      window.removeEventListener("beforeunload", handler);
    };
  }, [hasFilters]);

  const formatDate = (dateString: any) => {
    return dateString ? format(new Date(dateString), "yyyy-MM-dd") : null;
  };
  useEffect(() => {
    if (openList === "score" && minScoreRef.current) {
      minScoreRef.current.focus();
    }
  }, [openList]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const debouncedResults = useMemo(() => {
    return debounce(handleSearchChange, 300);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };



    const taskId =
        getDownloadStatus === STATUS.SUCESS &&
            attemptsExpertDownload &&
            typeof attemptsExpertDownload === 'object' &&
            'task_id' in attemptsExpertDownload
            ? (attemptsExpertDownload as { task_id: string }).task_id
            : undefined;


    const handleDownloadForTask = async () => {
        const response = await dispatch(getTestAttemptsDownload({
            project_id: id,
            export_type: 'grouped',
            download: true
        }));
        if (response?.payload?.data?.data?.task_id) {
            dispatch(getOutputJsonTaskStatus({ celery_task_id: response.payload.data.data.task_id }));
        }
        handleMenuClose();
    };

    const handleDownloadForReview = async () => {
        const response = await dispatch(getExpertTestAttemptsDownload({
            project_id: id,
        }));
        const taskId = response?.payload?.data?.data?.task_id;
        setCeleryTaskId(taskId);
        setTaskStatusModalOpen(true);
        setTaskStatusData({ status: 'PENDING' });
        if (taskId) {
            dispatch(getOutputJsonTaskStatus({ celery_task_id: taskId }));
        }
        handleMenuClose();
    };

    usePollingTaskStatus({
        status: taskStatusOutputJsonResponse?.data?.status,
        taskId,
        onSuccess: () => {
            console.log('Polling finished successfully');
        },
        onFailure: () => {
            console.log('Polling failed');
        },
    });


    React.useEffect(() => {
        const status = taskStatusOutputJsonResponse?.data?.status;
        if (status === 'PENDING' || status === 'SUCCESS' || status === 'FAILURE') {
            setOpenTaskStatusModal(true);
        }
    }, [taskStatusOutputJsonResponse]);


    React.useEffect(() => {
        if (
            getTaskStatusOutputJson === STATUS.SUCESS &&
            taskStatusOutputJsonResponse?.data?.url
        ) {
            const url = taskStatusOutputJsonResponse.data.url;

            setSnackbarMessage("File Available for download.");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);

            if (typeof url === "string") {
                fetch(url)
                    .then((response) => response.blob())
                    .then((blob) => {
                        const blobUrl = window.URL.createObjectURL(blob);
                        const link = document.createElement("a");
                        link.href = blobUrl;
                        const filename = url.split("/").pop() || "downloaded-file";
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(blobUrl);
                    })
                    .catch(() => alert("Failed to download file"));
            }
        }

        if (getTaskStatusOutputJson === STATUS.FAILED) {
            setSnackbarMessage(getTaskStatusOutputJsonMessage);
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }

        return () => {
            if (
                getTaskStatusOutputJson === STATUS.SUCESS ||
                getTaskStatusOutputJson === STATUS.FAILED
            ) {
                dispatch(setTaskStatus(STATUS.NOT_STARTED));
            }
        };
    }, [getTaskStatusOutputJson, taskStatusOutputJsonResponse]);


  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSnackbar = (
    message: string,
    severity: "success" | "error" | "info" | "warning"
  ) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteClick = (userId: string) => {
    setUserIdToDelete(userId);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setShowDeleteModal(false);
    try {
      dispatch(
        updateProjectExpert({
          project_id: id,
          expert_id: userIdToDelete,
          type: "TASK",
          is_bumped_up_by_admin: true,
        })
      );
      dispatch(
        getTestAttempts({
          project_id: id,
          page: currentPage,
          paginate: true,
          pageSize: itemsPerPage,
          search: searchTerm,
        })
      );
      handleSnackbar("Expert Promoted Successfully.", "success");
    } catch (error) {
      handleSnackbar("Error occured please try again.", "success");
    }
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleEditClick = (row: any) => {
    navigate(`/addexpert/${row.id}`, {
      state: { expertDetails: row, id: row.id },
    });
  };

  const handleChangeRowsPerPage = (value: number) => {
    setItemsPerPage(value);
    setCurrentPage(1);
    dispatch(
      getExpert({ search: searchTerm, page: 1, pageSize: value as number })
    );
  };

  const handleOnChange = (value: number) => {
    setItemsPerPage(value);
  };

    const handleClick = (row: any) => {
        setDrawer(true);
        setAttemptId(row.expert_id || '')
    }

    const headers = ["EXPERT EMAIL", "EXPERT NAME", "GIG SOURCE ID", "VENDOR PSEUDONAME", "TOTAL ATTEMPTS", "STATUS", "START TIME", "SCORE", "SCORE %'ge", "TIME TAKEN", 'ACTIONS'];

  useEffect(() => {
    if (updateStatus === STATUS.SUCESS) {
      setShowDeleteModal(false);
      dispatch(setUpdateExpertsStatus(STATUS.NOT_STARTED));
    }
  }, [updateStatus]);

  const totalPages = Math.ceil((attempts.count || 0) / itemsPerPage);

    // Filter Logic
    const handleFilterClick = (event: any) => {
        setAnchorE3(event.currentTarget);
    }
    const handleFilterClose = () => {
        setAnchorE3(false);
        setSearchType("")
    }
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue)
    }

  const handleNumberOfAttemptsToggle = (listName: string) => {
    setAttemptListOpen(!attemptListOpen);
    setfilterInFocus("attempt");
    setOpenList((prev) => (prev === listName ? null : listName));
  };
  const resetAttemptList = () => {
    setAttemptValue(null);
  };
  const resetScore = () => {
    setMinScore("");
    setMaxScore("");
  };
  const resetDateRange = () => {
    setStartDate(null);
    setIsEndDateOpen(false);
    setEndDate(null);
  };
  const resetPercent = () => {
    setPassingPercentOpen(false);
    setMinPercent("");
    setMaxPercent("");
  };

  const parseDate = (dateStr?: string): Date | null => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day); // month is 0-indexed
  };

  const updateURL = () => {
        const params = new URLSearchParams(window.location.search)

        const filters = {
            attemptValue,
            attemptStatus,
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
            searchType,
            minScore,
            maxScore,
            minPercent,
            maxPercent,
        };

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                params.set(key, value.toString());
            } else {
                params.delete(key);
            }
        });

        window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
    };

    const handleApplyClick = () => {
        if (minScore > maxScore) {
            handleSnackbar("Minimum score cannot be greater than maximum score.", "error");
            return
        }
        if (minPercent > maxPercent) {
            handleSnackbar("Minimum passing percentage cannot be greater than maximum passing percentage.", "error");
            return
        }
        dispatch(getTestAttempts({
            project_id: id,
            attempt_count: attemptValue,
            attempt_status: attemptStatus.map((s: any) => s.toUpperCase()).join(','),
            start_date: startDate,
            end_date: endDate,
            min_score: minScore,
            max_score: maxScore,
            min_percent: minPercent,
            max_percent: maxPercent,
        }))
        updateURL()
        setAnchorE3(false)
    }
    const handleReset = () => {
        const confirmReset = window.confirm("Are you sure you want to reset all filters? All selected filters will be removed.");
        if (confirmReset) {
            const url = window.location.pathname;
            window.history.pushState({}, '', url);
            window.location.reload()
        }
    }

    const handleByTaskListClick = (listName: string) => {
        setStatusOpen(!statusOpen)
        setfilterInFocus("by_task_list_open");
        setOpenList((prev) => (prev === listName ? null : listName))
    }

    const resetStatus = () => {
        setAttemptStatus([]);
    }
    const handleDateRange = (listName: string) => {
        setdateOpen(!dateOpen)
        setfilterInFocus("by_select_vendor_open");
        setOpenList((prev) => (prev === listName ? null : listName))
    }

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(formatDate(date) ?? null);
    setIsEndDateOpen(true);
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(formatDate(date) ?? null);
    setIsEndDateOpen(false);
  };
  const handleClearSelectedDates = () => {
    setEndDate(null);
    setStartDate(null);
  };

  const statuses = ["Passed", "Failed", "Incomplete"];


    const filters: any = [
        {
            name: 'attempts',
            label: 'Number of Attempts',
            type: 'text',
            value: attemptValue,
            onChange: setAttemptValue,
            reset: resetAttemptList,
            inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                min: 0
            }
        },
        {
            name: 'status',
            label: 'Status',
            type: 'multiselect',
            options: statuses.map(s => ({ label: s, value: s })),
            value: attemptStatus,
            onChange: setAttemptStatus,
            reset: resetStatus,
        },
        {
            name: 'score',
            label: 'Score Range',
            type: 'range',
            minValue: minScore,
            maxValue: maxScore,
            onMinChange: setMinScore,
            onMaxChange: setMaxScore,
            reset: resetScore,
            placeholderMin: "Min Score",
            placeholderMax: "Max Score",
        },
        {
            name: 'dateRange',
            label: 'Date Range',
            type: 'dateRange',
            startDate,
            endDate,
            onStartDateChange: handleStartDateChange,
            onEndDateChange: handleEndDateChange,
            reset: resetDateRange,
            clear: handleClearSelectedDates
        },
        {
            name: 'passingPercent',
            label: 'Passing Percentage',
            type: 'range',
            minValue: minPercent,
            maxValue: maxPercent,
            onMinChange: setMinPercent,
            onMaxChange: setMaxPercent,
            reset: resetPercent,
            placeholderMin: "Min %",
            placeholderMax: "Max %",
            adornment: "%",
        }
    ]


    return (
        <>
            <Drawer
                anchor={"right"}
                open={drawer}
                onClose={() => setDrawer(false)}
                PaperProps={{ sx: { width: "60%", padding: "30px" } }}
            >
                <AttemptHistory drawer={drawer} attemptId={attemptId || ''} setDrawer={setDrawer} />
            </Drawer>
            <Drawer
                anchor={"right"}
                open={anchorE3}
                onClose={() => setAnchorE3(false)}
                PaperProps={{ sx: { width: "20%", padding: "40px" } }}
            >
                <DrawerFilters
                    filters={filters}
                    onApply={handleApplyClick}
                    onResetAll={handleReset}
                    setOpenDrawerFilter={setAnchorE3}
                // stages={getReviewStages?.results || []}
                />
            </Drawer>

            <div className={classes.container}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ marginLeft: "0px" }}><SearchBar searchtext={"with email"} onSearchChange={debouncedResults} /></div>
                </div>



                <div className={classes.actionsContainer}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginRight: "20px",
                        }}
                    >
                        <IconButton
                            // style={{
                            //     height: '40px',
                            //     borderRadius: '10px',
                            //     padding: '8px 6px 8px 6px',
                            //     marginTop: '10px',
                            //     color: 'white',
                            //     marginRight: '20px',
                            //     backgroundColor: getDownloadStatus === STATUS.PENDING ? '#dfdfdf' : '#3D85C6',
                            // }}
                            sx={{
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                background: "linear-gradient(45deg, #42a5f5, #478ed1)",
                                borderRadius: "30%",
                                transition: "transform 0.3s ease-in-out",
                                "&:hover": {
                                    background: "linear-gradient(45deg, #478ed1, #42a5f5)",
                                    transform: "scale(1.1)",
                                },
                            }}
                            //onClick={handleExpertAnalyticsDownload}
                            onClick={handleMenuClick}
                            disabled={getDownloadStatus === STATUS.PENDING || getDownloadRawDataStatus === STATUS.PENDING}

                        >
                            {(getDownloadStatus === STATUS.PENDING || getDownloadRawDataStatus === STATUS.PENDING) ? <CircularProgress size={25} style={{ color: "white" }} /> : <DownloadIcon fontSize="medium" style={{ color: "white" }} />}
                        </IconButton>
                    </Box>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                    >
                        <Tooltip title="Download data grouped by expert email for a summarized view." arrow placement='left'><MenuItem onClick={handleDownloadForTask}>Group by Experts</MenuItem></Tooltip>
                        {!association_type_vendor && <Tooltip title="Download each attempt of an expert individually for a detailed and clear view." arrow placement='left'><MenuItem onClick={handleDownloadForReview}>Raw Data</MenuItem></Tooltip>}
                    </Menu>


                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginRight: "20px",
                        }}
                    >
                        <IconButton
                            color="primary"
                            aria-label="filter options"
                            onClick={handleFilterClick}
                            value={selectedValue}
                            autoFocus={false}
                            sx={{
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                background: "linear-gradient(45deg, #42a5f5, #478ed1)",
                                borderRadius: "30%",
                                transition: "transform 0.3s ease-in-out",
                                "&:hover": {
                                    background: "linear-gradient(45deg, #478ed1, #42a5f5)",
                                    transform: "scale(1.1)",
                                },
                            }}
                        >
                            <Tooltip title={
                                "Filters"
                            }
                                placement="bottom-end"
                                arrow>
                                <FilterAltIcon fontSize="medium" sx={{ color: "white" }} />
                            </Tooltip>
                        </IconButton>
                    </Box>

          <PaginationEntries
            itemsPerPage={itemsPerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            handleOnChange={handleOnChange}
          />
        </div>
      </div>

            <TableContainer style={{ minHeight: '75px' }}>
                {getStatus === STATUS.PENDING && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <CircularProgress />
                    </div>
                )}
                {getStatus === STATUS.SUCESS && (
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#F7F9FA', '&:first-child td, &:first-child th': { borderBottom: 0 } }}>
                            <TableRow>
                                {headers.map((header: string) => (
                                    <TableCellHead key={header}>{header}</TableCellHead>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {getStatus === STATUS.SUCESS && attempts && attempts.results && attempts.results.length > 0 ? (
                                attempts.results.map((row: any) => (
                                    <TableRowItem
                                        key={row.id}
                                        row={row}
                                        onEditClick={handleEditClick}
                                        onDeleteClick={handleDeleteClick}
                                        handleClick={handleClick}
                                    />
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={8} className={classes.noUsersMessage}>
                                        <Error message={'There are no attempts yet.'} />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                )}
                <DeleteModal
                    open={showDeleteModal}
                    onCancel={cancelDelete}
                    onConfirm={confirmDelete}
                    deleteText='Promote'
                />
            </TableContainer>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                paginate={paginate}
                itemsPerPage={itemsPerPage}
            />
            <SnackbarNotification
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={handleSnackbarClose}
            />
        </>
    );
};

export default TestAttemptsListTable;